import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function Star2Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16 25.4492L23.2748 29.7461C24.607 30.5336 26.2373 29.3695 25.8867 27.8972L23.9584 19.8169L30.3918 14.373C31.5663 13.3801 30.9352 11.4969 29.3926 11.3771L20.9258 10.6752L17.6127 3.04C17.0167 1.65333 14.9833 1.65333 14.3873 3.04L11.0742 10.6581L2.60739 11.36C1.06479 11.4798 0.433719 13.3629 1.6082 14.3559L8.04156 19.7998L6.11331 27.8801C5.76272 29.3524 7.39297 30.5165 8.72522 29.729L16 25.4492Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
